export const selectNotifications = state => state.notifications
